import { X, Info, AlertTriangle, CheckCircle, XCircle, Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { PlatformAnnouncement } from "@/hooks/useTenantAnnouncements";

interface FloatingBannerProps {
  announcement: PlatformAnnouncement;
  onDismiss: () => void;
}

const typeStyles: Record<string, string> = {
  info: "bg-blue-600 text-white",
  warning: "bg-yellow-500 text-yellow-950",
  success: "bg-green-600 text-white",
  error: "bg-destructive text-destructive-foreground",
  promotion: "bg-purple-600 text-white",
};

const typeIcons: Record<string, React.ReactNode> = {
  info: <Info className="h-4 w-4 flex-shrink-0" />,
  warning: <AlertTriangle className="h-4 w-4 flex-shrink-0" />,
  success: <CheckCircle className="h-4 w-4 flex-shrink-0" />,
  error: <XCircle className="h-4 w-4 flex-shrink-0" />,
  promotion: <Gift className="h-4 w-4 flex-shrink-0" />,
};

export const FloatingBanner = ({ announcement, onDismiss }: FloatingBannerProps) => {
  return (
    <div className={`fixed top-0 left-0 right-0 z-[100] ${typeStyles[announcement.type] || typeStyles.info}`}>
      <div className="flex items-center justify-center gap-3 px-4 py-2.5 text-sm">
        {typeIcons[announcement.type]}
        <span className="font-medium">{announcement.title}</span>
        {announcement.content && (
          <span className="hidden sm:inline opacity-90">— {announcement.content}</span>
        )}
        {announcement.is_dismissible && (
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6 hover:bg-white/20 text-current ml-2"
            onClick={onDismiss}
          >
            <X className="h-3.5 w-3.5" />
          </Button>
        )}
      </div>
    </div>
  );
};
